import { AppData, Log, Utils } from '@lightningjs/sdk'
import { Helper } from '../lib/helper'
import { PlatformBase } from './platform-base'
import { getDeviceIp, getSiteConfig, initSecurityToken } from '../lib/models/data-service'
import { KeyCodes } from '../lib/key-codes'
import { AppSetup } from '../lib/app-setup'
import { Logger } from '../lib/logger'
import VideoScreen from '../pages/video-screen'
import Router from '@lightningjs/sdk/src/Router'

export class PlatformSamsung extends PlatformBase {
  systemApi: any = null
  isVideoSuspended: boolean
  constructor() {
    super()
    this._setKeys()
    this.keyMap = {
      413: 'Stop',
      415: 'Play',
      19: 'Pause',
      412: 'Rewind',
      417: 'Forward',
      418: 'Next',
      419: 'Previous',
      10182: 'Exit',
      10009: 'Back',
      10252: 'XF86PlayBack',
    }
  }

  override setKeyMappings(appSettings: any) {

    const registerKeyList = [
      'ColorF3Blue',
      'MediaPlayPause',
      'MediaRewind',
      'MediaFastForward',
      'MediaPlay',
      'MediaPause',
      'MediaStop',
      'MediaTrackPrevious',
      'MediaTrackNext',
      'Caption',
      'Exit',
      'Info'
    ]
    if (window.tizen) {
      window.tizen.tvinputdevice.registerKeyBatch(registerKeyList)
    }
    appSettings.keys = this.keyMap
  }

  override _setKeys() {
    KeyCodes.KEY_STOP = 413;
    KeyCodes.KEY_PLAY = 415;
    KeyCodes.KEY_PLAYPAUSE = 10252; //XF86PlayBack
    KeyCodes.KEY_PAUSE = 19;
    KeyCodes.KEY_REWIND = 412;
    KeyCodes.KEY_FORWARD = 417;
    KeyCodes.KEY_NEXT = 418;
    KeyCodes.KEY_PREVIOUS = 419;
    KeyCodes.KEY_BACK = 461;
    KeyCodes.KEY_EXIT = 10182;
  }

  override async initialize(): Promise<boolean> {
    this._shouldShowExitPopup = true
    const { appState, appConfig } = AppData as AppSetup
    const app = appState?.getApp()!
    if (app.siteId == '236') {
      appConfig.siteId = '1285'
      app.siteId = '1285'
    }
    appConfig.enableCCSettings = true
    appConfig.enableRetries = true
    appConfig.enableNetworkDisconnectionCheck = true
    Log.info('PlatformBase:', typeof this)
    this._siteConfig = await getSiteConfig()
    Log.info('PlatformBase: siteConfig: ', this._siteConfig)
    // commented the code for enabling live tv for Samsung
    //appConfig.enableLiveRow = false //disabling the live tv for this build.
    Helper.getSiteConfigInfo(this._siteConfig)
    

    if(appConfig.enableSecurityToken){
      appConfig?.apiVersion = "sv9.0";      
      var securityToken = Helper.getCookie("_token");
      if (securityToken) {
        appConfig.securityToken = securityToken;
      } else {
        var securityTokenAPIResp = await initSecurityToken();
        appConfig.securityToken = securityTokenAPIResp.securityToken;
        Helper.setGeneralCookie("_token", appConfig.securityToken, 1);
      }
    }
    
    window.addEventListener('appcontrol', (event) => {
      Log.info('PlatformBase: appcontrol ', event)
      if (event && event.type == 'appcontrol') {
        let payload = this.getPayloadData()
        this.handleDeeplinkInturrep(payload)
      }
    });
    document.addEventListener("visibilitychange", this.handleMultiTaskingAppSwitching.bind(this));
    return new Promise(async (resolve, reject) => {

      Log.info('PlatformBase:', typeof this)
      if (window.webapis) {
        const webapis = window.webapis
        try {
          this._firmwareVersion = webapis.productinfo.getFirmware(); //shows OS version. use this
        }catch (e) {}
        try {
          this._deviceId = webapis.productinfo.getDuid(); //Unique id for smart hub (not tv serial number). use this
        } catch (e) {
          //on the Emulator, this API returns error. henece, setting the the deviceId to static string
          this._deviceId = 'EMULATOR12345'
        }
        if(webapis && webapis.adinfo) {
          this._ifa = webapis.adinfo.getTIFA()
          this._ifaType = 'tifa'
          //Fix for XFIN-1201
          //this._limitAdTracking = webapis.adinfo.isLATEnabled().toString()
          let lmt = webapis.adinfo.isLATEnabled();
          if (lmt === true) {
              this._limitAdTracking = '1';
          } else {
              this._limitAdTracking = '0';
          }          
        }
        this._fullModel = webapis.productinfo.getRealModel();
        
      }
      resolve(true)
    })
  }

  handleDeeplinkInturrep(payload) {
    Log.info('handleDeeplinkInturrep: ', payload)
    const { appState } = AppData as AppSetup
    const app = appState?.getApp()!
    const route = Router.getActiveRoute()!
    if (route.indexOf('video') > -1) {
      const page: VideoScreen = Router.getActivePage()
      page.hitCloseTracker()
      page.closeVideo(true)
      app?.handleBackNavigation();
    }
    //fix for IPTV-2085
    while (app.navigation.continuesStack.length > 1) {
      app.navigation.pop()
    }
    app.loadDeeplinkInterrupt(payload)
  }

  handleMultiTaskingAppSwitching(event) {
    Log.info('visibilitychange: ', document.hidden)
    const { appConfig, appState } = AppData as AppSetup;
    const route = Router.getActiveRoute()!
    const app = appState?.getApp()
    if (document.hidden) {
      appState.appUnload = true
      if (route.indexOf('video') > -1) {
        this.isVideoSuspended = true
        const page: VideoScreen = Router.getActivePage()
        const { appState } = AppData as AppSetup;
        const app = appState?.getApp();
        app.suspendedAppStack = [...app.navigation.continuesStack]
        //page.handleInactiveEvent()
        page.hitCloseTracker()
        page.closeVideo(true)
        app?.handleBackNavigation();
      }
      Logger.processUserAction('userExitedViaRemoteDirectly', 'App suspended')
    } else {
      appConfig.sessionId = Helper.generateSessionId();
      Log.info('appResumed: sessionId', appConfig.sessionId)
      Logger.processUserAction('appResumedFromSuspend', 'App resumed')      
      let payload = this.getPayloadData()
      if (payload) {
        this.isVideoSuspended = false
        this.handleDeeplinkInturrep(payload)
      } else {
        this.handleResume()
      }
      
    }
    //console.log("APP: BEFORE UNLOAD APP");
  }

  // async checkBuildVersionChange() {
  //   const { appConfig } = AppData as AppSetup
  //   const {tizen, environment, _rootConfig} = window
  //   const packageVer=(tizen ?  tizen.package.getPackageInfo().version : '2.0.0')
  //   const _url = environment[_rootConfig.env] + '/?platform_id=' + _rootConfig.auth_token + '&siteId=' + _rootConfig.siteId + '&appVer=' + packageVer;
  //   try {
  //     const resp = await fetch(_url)
  //     let newVer = await resp.text()
  //     newVer = newVer.split('/')[1]!
  //     const curVer = appConfig?.buildVersion
  //     if(curVer !== newVer) {
  //       return true
  //     }
  //   } catch(e) {
  //     return false
  //   }
  // }

  async handleResume() {
    // const isVersionChange = await this.checkBuildVersionChange()
    // if(isVersionChange) {
    //   window.location.reload()
    //   return;
    // }
    //Sending the source info to the logger as instance-resume string
    Logger.logSourceInfo(true)
    // fix for IPTV-2189
    if (this.isVideoSuspended) {
      const { appState } = AppData as AppSetup;
      const app = appState?.getApp();
      app.navigation.continuesStack = [...app.suspendedAppStack]
      app.suspendedAppStack = []
      const vodInfo = app.navigation.getCurrentVodInfo()
      if(vodInfo.actiontype == 'live') {
        Router.navigate('video-screen-live/' + vodInfo.node_id + '_resume', false)
      } else {
        Router.navigate('video-screen/' + vodInfo.node_id + '_resume', false)
      }
    }
    this.isVideoSuspended = false
  }

  override sendMetrics(eventType: string, dataObj: any) {
    Log.info('Send Metrics:', eventType, dataObj)
    switch (eventType) {
      case 'close':
        Logger.processUserAction('userExitedAppUsingExitWindow');
        setTimeout(() => {
          if (window.tizen) {
            window.tizen.application.getCurrentApplication().exit();
          }
        })
        break;
    }
  }

  getPayloadData() {
    let payload = null;
    const { tizen, devParams } = window

    const reqAppControl = tizen && tizen.application.getCurrentApplication().getRequestedAppControl();
    if (devParams && devParams.debug && devParams.playId !== '') {
      let pObj = { values: devParams.playId }
      if (reqAppControl && reqAppControl.appControl) {
        const pl = new tizen.ApplicationControlData('PAYLOAD', [JSON.stringify(pObj)]);
        reqAppControl.appControl.data.push(pl);
      }
    }
    try {
      if (reqAppControl && reqAppControl.appControl) {
        var appControlData = reqAppControl.appControl.data;
        for (var i = 0; i < appControlData.length; i++) {
          if (appControlData[i].key == 'PAYLOAD') {
            var pdataStr = appControlData[i].value[0];
            //app.payloadStr = pdataStr;
            //app.appState.deeplinks.payloadStr = pdataStr;
            payload = JSON.parse(pdataStr).values;
          }
        }
      }
    } catch (e) {
      // TODO: handle exception
    }
    if (!payload) {
      return null;
    }
    let jsonData = JSON.parse(payload);
    let finalData = this.parseDeeplinkData(jsonData);
    if (devParams.debug) {
      if ($('#deeplink-disp-div')[0]) {
        $('#deeplink-disp-div').text('Paylod data: ' + finalData)
      } else {
        $('body').append('<div id="deeplink-disp-div" style="position: absolute;top: 80px;z-index: 999999;background-color: #000;color: #fff;font-size: 1.6em;">Paylod data: ' + finalData + '</div>')
      }
    }
    return finalData;
  }

  parseDeeplinkData = (data) => {
    let params = '';
    let arr = [];
    if (data && data.assetId) {
      let paramStr = atob(data.assetId);
      let paramObj = JSON.parse(paramStr);
      for (let key in paramObj) {
        arr.push(`${key}=${paramObj[key]}`);
      }
      // if (data.src) {
      //     arr.push(`src=${data.src}`);
      // }
    } else if (data && data.playId) {
      arr.push('playId=' + data.playId);
    }
    if (data.src) {
      arr.push(`src=${this._getDeeplinkType(data.src)}`);
    }
    if (arr.length > 0) {
      params = '?' + arr.join('&');
    }
    return params;
  }

  _getDeeplinkType(dType: string): string {
    switch (dType) {
      case 'search':
        return 'hs-search'
      case 'promo':
        return 'hs-d'
      case 'preview':
        return 'recommendationbytheapp'
      default:
        return 'hs-search'
    }
  }

  override getPlatformDeeplinkData(): Promise<string> {
    return new Promise((resolve, reject) => {
      let payload = this.getPayloadData()
      // check the deeplink params at Home launch / first launch.
      if (payload) {
        resolve(payload)
      } else {
        resolve('')
      }
    })
  }

  // override getAppStoreId(indexObj: any): string {
  //   if (indexObj && indexObj?.vizioAppId) return indexObj?.vizioAppId
  //   return ''
  // }

  override getOptionsIconPath(apiOptionsIcon: string | undefined) {
    // if(apiOptionsIcon && apiOptionsIcon !== '') {
    //   return apiOptionsIcon
    // }
    return Utils.asset('/images/option-blue.png')
  }

  override getAppStoreId(type=''): string {
    const { appState } = AppData as AppSetup
    const appApiConfig = appState?.getAppApiConfig()
    if(type == 'ad') {
      if (appApiConfig && appApiConfig.appConfig.samsungAppStoreId) {
        return appApiConfig.appConfig.samsungAppStoreId
      }
    } else if (appApiConfig && appApiConfig.appConfig.samsungAppId) {
      return appApiConfig.appConfig.samsungAppId
    }
    return ''
  }

  override isOptionsKey(e: KeyboardEvent): boolean {
    // console.log('isOptionsKey: ', e)
    if (e.keyCode == KeyCodes.KEY_BLUE || e.code == 'KeyB') {
      return true
    }
    return false
  }

  override getOptionsText() {
    return 'Press Blue for Options'
  }

  override getScript(platformSettings):string[] {
    return [
      platformSettings.path + 'modules/hlsjs/hls.min.js',
      platformSettings.path + 'modules/dashjs/dash.all.min.js',
    ]
  }

  //Ad Macros related value mapping functions based on the platform.

  override getAppNameMacro(appName: string, siteId?:string): string {
    const {appConfig } = AppData as AppSetup;
    let videoAppName = this.SamsungAppNameMap.find((item) => item[0].toLowerCase() === siteId)
    if(videoAppName) {
      return videoAppName[2];
    }
    return appName.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
  }

  SamsungAppNameMap: string[][] = [ 
    ['1285', 'fawefiretv', 'fawesome'],
  ]

}
